import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Spinner from 'web/components/Spinner';
import Layout from 'web/components/Layout';
import { Container } from './myOrderStyled'
import OrderTabs from './Tabs/OrderTabs'
import { logoutClearRedux } from 'redux/actions/auth';

const OrderDetails = (props) => {
  const [urlSearchParams, setURLSearchParams] = useState();
  let history = useHistory();
  let dispatch = useDispatch();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.ptPlusPage);
  const storedData = useSelector((state) => state.storedData.payload);

  const accountType = localStorage.getItem('accountType')
  let selectedSearch;
  if (accountType === "Seller") {
    selectedSearch = "PostLoad"
  }
  if (accountType === "Buyer") {
    selectedSearch = "PostInventory"
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [expanded, expandedState] = useState();
  useEffect(() => {
    const { location } = props;
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.get("pageType")) {
      setURLSearchParams({
        pageType: queryParams.get("pageType"),
        selectedTab: queryParams.get("selectedTab"),
      })
      expandedState(queryParams.get("expanded"))
    } else {
      if (urlObject) {
        setURLSearchParams({
          pageType: urlObject.pageType,
          selectedTab: urlObject.selectedTab,
        })
        expandedState(urlObject.expanded)
      } else {
        setURLSearchParams({
          pageType: 'PtPlusPage',
          selectedTab: queryParams.get("selectedTab"),
        })
        expandedState('sideBar')
      }
    }
    if (!localStorage.getItem('token')) {
      history.push('/sign-in')
      window.location.reload(false);
    }
  }, []);

  if (!storedData?.data?.isEnablePtPlusFeature) {
    dispatch(logoutClearRedux());
    localStorage.clear();
    history.push('/sign-in')
    window.location.reload(false);
  }

  return (<>
    <Layout pageType="PtPlusPage" selectedSearch={selectedSearch} topBarViewMobile={'hide'}>
      {loaderVisible && <Spinner />}
      <Container>
        {urlSearchParams && <OrderTabs urlSearchParams={urlSearchParams} expanded={expanded} />}
      </Container>
    </Layout>
  </>)
};

export default OrderDetails;